import React from 'react';
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu';
import { formatMonthLong, shiftMonth, isFutureMonth } from '../../../utils/monthUtils';

/**
 * Prev / Month / Next — a three-part control. Next is disabled when
 * moving forward would step into a future month.
 */
function MonthSelector({ month, onChange, disabled = false }) {
  const prev = shiftMonth(month, -1);
  const next = shiftMonth(month, +1);
  const nextDisabled = disabled || isFutureMonth(next);

  return (
    <div className="gc-insights-month" role="group" aria-label="Change month">
      <button
        type="button"
        className="gc-insights-month-btn"
        aria-label={`Previous month, ${formatMonthLong(prev)}`}
        onClick={() => onChange(prev)}
        disabled={disabled}
      >
        <LuChevronLeft aria-hidden="true" />
      </button>
      <span className="gc-insights-month-label" aria-live="polite">
        {formatMonthLong(month)}
      </span>
      <button
        type="button"
        className="gc-insights-month-btn"
        aria-label={
          nextDisabled
            ? 'Next month (unavailable)'
            : `Next month, ${formatMonthLong(next)}`
        }
        onClick={() => onChange(next)}
        disabled={nextDisabled}
      >
        <LuChevronRight aria-hidden="true" />
      </button>
    </div>
  );
}

export default MonthSelector;
